export default __webpack_public_path__ + "static/media/gift-card.inline.3e76e532.svg";